import { LogoMark } from "./Logo";

const WORDS = ["Furniture", "BBQs", "Gazebos", "Sheds", "Fitness Gear", "TV Mounts", "Blinds", "Shelving", "Fence Gates", "Practically Anything"];

const Row = () => (
  <div className="flex items-center shrink-0">
    {WORDS.map((w, i) => (
      <div key={w} className="flex items-center">
        <span className={`font-display font-black uppercase text-6xl sm:text-8xl lg:text-[9rem] leading-none px-6 lg:px-10 ${i % 2 ? "text-outline" : "text-white"}`}>{w}</span>
        <LogoMark className="w-10 h-10 lg:w-14 lg:h-14 shrink-0" />
      </div>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="marquee-wrap relative py-14 lg:py-20 border-y border-[var(--line)] bg-[var(--ink)] overflow-hidden" data-testid="services-marquee" aria-label="Services we assemble and install">
    <div className="marquee-track flex w-max">
      <Row /><Row />
    </div>
  </section>
);
